var $1df8c58f234da60a$exports = {};
$1df8c58f234da60a$exports = {
    "decrease": (args)=>`Smanji ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{107}aj ${args.fieldLabel}`,
    "numberField": `Polje broja`
};


export {$1df8c58f234da60a$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
